/** Intervalo padrão (s) para polling de session-status — usado se não houver config. */
export const SSO_SESSION_POLL_SECONDS_DEFAULT = 10;

export const SSO_SESSION_ACTIVE_KEY = "ssoSessionActive";

export function getPollIntervalMs() {
  const fromEnv = Number(process.env.REACT_APP_SSO_SESSION_POLL_SECONDS);
  if (!Number.isNaN(fromEnv) && fromEnv > 0) return fromEnv * 1000;
  return SSO_SESSION_POLL_SECONDS_DEFAULT * 1000;
}

export function markSsoSessionActive() {
  localStorage.setItem(SSO_SESSION_ACTIVE_KEY, "true");
}

export function clearSsoSessionMarker() {
  localStorage.removeItem(SSO_SESSION_ACTIVE_KEY);
}

export function isSsoSessionMarked() {
  return localStorage.getItem(SSO_SESSION_ACTIVE_KEY) === "true";
}

export async function fetchSsoSessionActive(sessionStatusUrl) {
  try {
    const response = await fetch(sessionStatusUrl, {
      method: "GET",
      credentials: "include",
    });
    return response.status === 200;
  } catch {
    return true;
  }
}

export async function callSsoSignOut(signOutUrl) {
  try {
    const response = await fetch(signOutUrl, {
      method: "GET",
      credentials: "include",
      keepalive: true,
      cache: "no-store",
    });

    return response.ok;
  } catch {
    return false;
  }
}
